//@ts-ignore
import { DashboardLayout as DashboardLayoutService } from "@careinfo/layout";

import { Outlet } from "react-router-dom";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
import NotificationIcon from "../Icons/NotificationIcon";
import UnreadNotificationicon from "../Icons/UnreadNotificationicon";
import NoticeIcon from "../Icons/NoticeIcon";

export const navigation: any = [
  {
    name: "Notification",
    href: "",
    icon: "",
    children: [
      {
        name: "All",
        href: "/notification/all",
        icon: NotificationIcon,
        activeIcon: NotificationIcon,
      },
      {
        name: "Read",
        href: "/notification/read",
        icon: NotificationIcon,
        activeIcon: NotificationIcon,
      },
      {
        name: "Unread",
        href: "/notification/unread",
        icon: UnreadNotificationicon,
        activeIcon: UnreadNotificationicon,
      },
      {
        name: "Notice",
        href: "/notification/notice",
        icon: NoticeIcon,
        activeIcon: NoticeIcon,
      },
    ],
  },
];

const DashboardLayout = () => {
  return (
    <DashboardLayoutService navigation={navigation}>
      <div className={tw` p-2 overflow-y-auto`}>
        <Outlet />
      </div>
    </DashboardLayoutService>
  );
};

export default DashboardLayout;
